import Cookie from 'js-cookie'
import { Redirect } from 'react-router-dom'

export const Logout = () => {
    Cookie.remove('onliveAdminId')
    return <Redirect to="/" />
}